import { TESTIMONIAL_PAGE } from './actionTypes';

const initialState = {
  testimonials: null,
  loading: {
    testimonials: false,
  },
  error: {
    testimonials: null,
  },
};

const TestimonialReducer = (state = initialState, action) => {
  const { type, payload, error } = action;
  switch (type) {
    case TESTIMONIAL_PAGE.TESTIMONIAL_PAGE_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, testimonials: true },
        error: { ...state.error, testimonials: null },
      };
    case TESTIMONIAL_PAGE.TESTIMONIAL_PAGE_SUCCESS:
      return {
        ...state,
        testimonials: payload,
        loading: { ...state.loading, testimonials: false },
      };
    case TESTIMONIAL_PAGE.TESTIMONIAL_PAGE_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, testimonials: false },
        error: { ...state.error, testimonials: error },
      };

    default:
      return state;
  }
};

export default TestimonialReducer;
